// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1m8iX","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1eUb2"};